<template>
  <div
    :id="id"
    class="modal-title-list-view modal-native-button-table">
    <h4 class="title">Edit Button</h4>
    <b-form :class="{'error-input': $v.dataSetup.label.$error}">
      <label> Label </label>
      <j-input
        v-model="dataSetup.label"
        :error-required="false"
        placeholder="Enter button label"
      />
    </b-form>
    <b-form class="mt-2">
      <label>Hidden Button</label>
      <j-toggle
        v-model="dataSetup.is_hidden"
        class="toggle"
      />
    </b-form>
    <div class="d-flex justify-content-end">
      <button
        class="button-border mr-2"
        @click="$emit('close-modal')"
      >
        Close
      </button>
      <button
        class="button-blue"
        @click="submitForm"
      >
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      dataSetup: {
        label: null,
        is_hidden: false,
      },
    };
  },

  created() {
    if (this.data) {
      const { label, is_hidden: isHidden } = this.data;
      this.dataSetup = {
        label,
        is_hidden: isHidden,
      };
    }
  },

  methods: {
    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$emit('submit', this.dataSetup);
      }
    },
  },

  validations() {
    return {
      dataSetup: {
        label: {
          required,
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/ModalNativeButtonTable.vue